import {Poi} from '../../react-app-env';
import React from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {noop} from '../../utils/Utils';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';

export interface ActionsGroupProps {
  poi: Poi;
}

const ActionsGroup: React.FunctionComponent<ActionsGroupProps> = ({ poi }) => {
  return <ListViewGroup>
    <ListViewItem title={i18n().poiDetails.actions.renamePoi}
                  iconCategory='fa-pencil'
                  decoration={DefaultItemDecorations.EDIT}
                  onClick={() => noop()}/>
    <ListViewItem title={i18n().poiDetails.actions.deletePoi}
                  iconCategory='fa-trash'
                  hoverColor='delete'
                  onClick={() => noop()}/>
  </ListViewGroup>;
};

export default ActionsGroup;
